import { Avatar } from "@mantine/core";

const ChevronRightIcon = ({ size }: any) => {
  return (
    <Avatar
      style={{
        cursor: "pointer",
      }}
      size={size}
      src={"/assets/chevronRight.png"}
    />
  );
};

export default ChevronRightIcon;
